<ng-container *transloco="let tloco; prefix: 'subscriptions.payment-methods'">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h1 class="text-heading-2" mat-dialog-title>{{ tloco('new') }}</h1>
    <span class="mx-5">{{ tloco('fine-print') }}</span>
    <mat-dialog-content>
      <rma-stripe-payment-element
        [clientSecret]="clientSecret$ | async"
        (loaded)="onStripeElementLoaded($event)"
        (changed)="onStripeElementChanged($event)"
      />
      <div class="flex flex-col">
        <mat-checkbox class="py-4" formControlName="isDefault">{{ tloco('set-default') }}</mat-checkbox>
        @if (error$ | async; as error) {
          <mat-error>{{ error }}</mat-error>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button type="button" mat-button color="primary" mat-dialog-close>{{ 'action.cancel' | transloco }}</button>
      <button type="submit" [rmaLoadingIndicator]="isSubmitting$ | async" [disabled]="!isComplete" mat-flat-button color="primary">
        <span>{{ tloco('add') }}</span>
      </button>
    </mat-dialog-actions>

    <button type="button" class="top-modal-close" mat-dialog-close>
      <rma-icon glyph="close" />
    </button>
  </form>
</ng-container>
